import ontologiesAxios from "./axiosInstance/ontologies";

const showDescriptions = code => ontologiesAxios.get(`/rxnormcode/${code}`);

const showCodes = description =>
  ontologiesAxios.get(`/rxnormdesc/${description}`);

const rxNormApi = {
  showDescriptions,
  showCodes,
};

export default rxNormApi;
